import { useUserPermissions } from './hooks/userPermissions';

// Rutas filtradas
export function FilteredRoutes({ routes }) {
  const userPermissions = useUserPermissions();

  const filteredRoutes = routes.filter((route) => {
    if (!route.requiredPermissions) {
      // Si la ruta no tiene permisos requeridos, se muestra para todos los usuarios
      return true;
    }

    // La ruta tiene permisos requeridos, se comprueba si el usuario los tiene
    return route.requiredPermissions.some((permission) =>
      userPermissions.includes(permission)
    );
  });

  return filteredRoutes;
}
